import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { setTrackingConsent } from '../lib/tracking';
import { syncTikTokConsent } from '../lib/tiktokTracking';

const getCookieValue = (name) => {
  const match = document.cookie.split('; ').find((row) => row.startsWith(`${name}=`));
  return match ? decodeURIComponent(match.split('=')[1]) : null;
};

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = getCookieValue('neuralia369_cookies');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    setTrackingConsent('accepted');
    syncTikTokConsent('accepted');
    window.dispatchEvent(new CustomEvent('neuralia-consent-updated', { detail: { status: 'accepted' } }));
    setVisible(false);
  };

  const handleReject = () => {
    setTrackingConsent('rejected');
    syncTikTokConsent('rejected');
    window.dispatchEvent(new CustomEvent('neuralia-consent-updated', { detail: { status: 'rejected' } }));
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-0 bottom-0 z-[45]"
          data-testid="cookie-banner"
        >
          <div className="border-t border-border-subtle bg-[rgba(3,8,22,0.92)] backdrop-blur-md px-4 py-3 sm:px-6">
            <div className="mx-auto flex max-w-7xl flex-col gap-3 md:flex-row md:items-center md:gap-6 md:pr-36">
              <p className="flex-1 text-text-muted text-xs leading-relaxed">
                <span className="text-text-heading font-semibold">Este sitio utiliza cookies.</span>{' '}
                Usamos cookies propias y de terceros para el funcionamiento técnico del sitio y, solo si aceptas, para analítica y medición. Puedes rechazar las no esenciales y revisar la información legal en cualquier momento.{' '}
                <Link to="/cookies" className="text-primary hover:underline">
                  Más información
                </Link>
              </p>
              <div className="flex flex-shrink-0 items-center gap-3">
                <button
                  onClick={handleReject}
                  className="px-4 py-2 text-sm text-text-muted hover:text-text-body transition-colors rounded-full border border-border-subtle hover:border-border-highlight"
                  data-testid="cookie-reject-btn"
                >
                  Solo necesarias
                </button>
                <button
                  onClick={handleAccept}
                  className="px-5 py-2 text-sm font-semibold bg-primary text-background rounded-full hover:scale-105 transition-transform"
                  data-testid="cookie-accept-btn"
                >
                  Aceptar todas
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
